import {prop, sortBy} from 'ramda';
import React, {useState} from 'react';

import {translate} from 'iss/strings';
import {useQueryState} from 'iss/hooks/useQueryState';
import {searchLateEvents} from 'iss/service/EvaluationEventService';
import {FlexItem, FlexRow} from 'iss/widgets/Flex';
import {LateEventsList} from 'iss/widgets/LateEventsList';
import {PagedSearchResults, SearchResultScroller, ShowAllResultsButton, TextSearchBar, formatResultCount} from 'iss/widgets/PagedSearchResults';
import {BatchOpRunnerDialog} from 'iss/widgets/batchOps/BatchOpRunnerDialog';
import BootstrapSelect from 'iss/widgets/bootstrap/Select';
import cancelEvents from 'iss/widgets/batchOps/lateEvents/cancelEvents';
import { SortOrderEnum } from '../widgets/SortColumnHeader';

function LateEventsListPage() {
  const [search, setSearch] = useQueryState({
    defaults: {query: "", sortFieldName: "PLANNED_DATE", sortOrder: SortOrderEnum.ASCENDING}
  });
  const [selected, setSelected] = useState([]);
  const [currentBatchOp, selectBatchOp] = useState(null);
  const getItems = (search, page, size) => {
    return searchLateEvents(search.query, search.sortFieldName, search.sortOrder, page, size, false);
  };

  function onChangeSort({sortFieldName, sortOrder}) {
    setSearch({query: search.query, sortFieldName: sortFieldName, sortOrder: sortOrder});
  }

  return <React.Fragment>
    <h1>
      {translate('lateEventsList.title')}
    </h1>
    <LateEventsSearch search={search} onChange={setSearch}/>
    <PagedSearchResults getItems={getItems} search={search}>
      {(results, resultApi) =>
        <React.Fragment>
          <LateEventsResultCount searchResult={results} selectedEvents={selected} onSelectBatchOp={selectBatchOp} onShowAll={resultApi.loadAllItems} />
          <SearchResultScroller searchResult={results} onLoadMore={resultApi.loadMoreItems}>
            <LateEventsSearchResults events={results.results} selected={selected} onChangeSelected={setSelected} onChangeSort={onChangeSort}/>
          </SearchResultScroller>
          <BatchOpRunnerDialog operation={currentBatchOp} operationTargets={selected}
            onClose={() => selectBatchOp(null)}
            onOperationDone={() => { selectBatchOp(null); setSelected([]); resultApi.reload(); }}
          />
        </React.Fragment>
      }
    </PagedSearchResults>
  </React.Fragment>;
}

function LateEventsSearch({search, onChange, onChangeSort}) {
  const {query} = search;
  return <TextSearchBar id="late-events-search" search={query}
    onChange={(newQuery) => onChange({query: newQuery})} onChangeSort={onChangeSort}>
  </TextSearchBar>;
}

function LateEventsResultCount({searchResult, selectedEvents, onSelectBatchOp, onShowAll}) {
  return <FlexRow alignItems="center" minHeight="3em">
      <FlexItem flex="none">
        {formatResultCount(searchResult)}
        <ShowAllResultsButton searchResult={searchResult} onShowAll={onShowAll} />
      </FlexItem>
      <FlexItem flex="none" className="form-inline">
        <LateEventsToolbar selectedEvents={selectedEvents} onChoose={onSelectBatchOp}/>
      </FlexItem>
    </FlexRow>;
}

function LateEventsToolbar({selectedEvents, onChoose}) {
  if (!selectedEvents.length) return null;

  return <React.Fragment>
    {translate('lateEventsList.editSelected') + " "}
    <LateEventsBatchOpChooser onChoose={onChoose} />
  </React.Fragment>;
}

function LateEventsSearchResults(props) {
  return <LateEventsList {...props} selectable={true} />;
}


const batchOps = [
  cancelEvents
];

export function LateEventsBatchOpChooser({onChoose}) {
  const options = batchOps
    .filter(op => ("canAccess" in op) ? op.canAccess() : true)
    .map((operation) => ({label: translate(operation.title), value: operation}));
  return <BootstrapSelect id="batchopChooser" options={sortBy(prop("label"), options)} onChange={({value}) => onChoose(value)}/>;
}

export default LateEventsListPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/LateEventsListPage.jsx